import React from "react";
import Layout from "../../Component/Layout";
import { TILE_REGISTRY } from "../../Component/Favourite/TileRegistry";
import PinToHome from "../../Component/Favourite/PinToHome";

function Gl() {
  const cards = Object.values(TILE_REGISTRY).filter(
    (t) => t.moduleName === "General Ledger"
  );

  const handleNavigate = (path) => {
    window.location.href = path;
  };

  return (
    <Layout>
      <div
        style={{
          padding: "30px 40px",
          backgroundColor: "#f8fafc",
          minHeight: "calc(100vh - 60px)",
        }}
      >
        <div style={{ marginBottom: "35px" }}>
          <h2
            style={{
              margin: "0 0 8px 0",
              color: "#0f172a",
              fontWeight: "700",
              fontSize: "28px",
            }}
          >
            General Ledger
          </h2>

          <p
            style={{
              color: "#64748b",
              margin: 0,
              fontSize: "15px",
            }}
          >
            Manage General Ledger.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: "24px",
          }}
        >
          {cards.map((item) => {
            const IconComponent = item.icon;

            return (
              <div
                key={item.id}
                onClick={() => handleNavigate(item.path)}
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  border: "1px solid #e2e8f0",
                  boxShadow:
                    "0 4px 6px -1px rgba(0,0,0,.05),0 2px 4px -1px rgba(0,0,0,.03)",
                  padding: "24px",
                  cursor: "pointer",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  height: "160px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "auto",
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg,#eff6ff 0%,#dbeafe 100%)",
                      color: "#3b82f6",
                      padding: "14px",
                      borderRadius: "12px",
                    }}
                  >
                    <IconComponent size={26} />
                  </div>

                  <div style={{ position: "relative" }}>
                    <PinToHome tileId={item.id} />
                  </div>
                </div>

                <div>
                  <h5
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0f172a",
                    }}
                  >
                    {item.name}
                  </h5>

                  <p
                    style={{
                      fontSize: "13px",
                      color: "#64748b",
                    }}
                  >
                    Open Module →
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}

export default Gl;